import QueryKeys from '@constants/queryKeys';
import { useWorkerStore } from '@worker/stores';
import { useMyJobsQueryState } from './useMyJobsQueryState';

/**
 * Custom hook that returns the standardized query key for MyJobs job recommendations.
 * Centralizes query key construction to ensure consistency across queries and mutations.
 *
 * @returns Query key array: [QueryKeys.MyJobs.JOB_RECOMMENDATIONS, currentTab, currentPage, apiQueryParams]
 */
export function useMyJobsQueryKey() {
  const currentTab = useWorkerStore((state) => state.currentTab);
  const { currentPage, apiQueryParams } = useMyJobsQueryState();

  return [
    QueryKeys.MyJobs.JOB_RECOMMENDATIONS,
    currentTab,
    currentPage,
    apiQueryParams,
  ] as const;
}
